import { Injectable } from '@angular/core';
import { TenantService } from "../../../../Services";
import {BehaviorSubject, Observable} from "rxjs";
import {filter, map, take} from "rxjs/operators";
import { IMobileListItem } from '../../../../Models/IMobileListItem';
import { IDictionary } from '../../../../Models/IDictionary';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private translations: IDictionary<IDictionary<string>>;
    private translationsReadyState: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private tenantService: TenantService) {

    }

    getTranslation(alias: string, property: string = null): Observable<string> {
        return this.translationsReadyState
            .pipe(
                filter(readyState => readyState === true),
                take(1),
                map(() => {
                    const parts = this.splitAliasParts(alias);
                    if (parts.length > 1 && this.translations) {
                        if (this.translations[parts[0]]) {
                            const result = this.translations[parts[0]][parts[1]];
                            if (result) {
                                if (property) {
                                    if (result.hasOwnProperty(property)) {
                                        return result[property];
                                    } else {
                                        return result;
                                    }
                                }
                                return result;
                            }
                        }
                    }
                    return TranslationService.prettify(alias);
                }));
    }

    pushTranslations(translations: any) {
        return this.tenantService.pushTranslations(translations);
    }

    rebuildTranslationsForTenant(tenant: string) {
        localStorage.removeItem(tenant + "_Translations");
        this.getTranslationsForTenant(tenant);
    }

    getTranslationsForTenant(tenant: string) {
        this.translationsReadyState.next(false);
        const translations = localStorage.getItem(tenant + "_Translations");
        if (translations == null) {
            this.tenantService.getAllLists(tenant).subscribe((translations: IMobileListItem[]) => {
                this.rebuildTranslations(translations);
                this.removeExistingKeysFromLocalStorage("_Translations");
                try{
                 localStorage.setItem(
                     tenant + "_Translations",
                     JSON.stringify(this.translations));
                 }
                 catch(e){
                    console.warn('Tenant translations could not be saved in local storage');
                 }
                this.translationsReadyState.next(true);
            });
        } else {
            this.translationsReadyState.next(true);
            this.translations = <IDictionary<IDictionary<string>>>JSON.parse(translations);
        }
        window["translations_"] = this.translations;
    }

    private removeExistingKeysFromLocalStorage(endsWith: string) {
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const itemKey = localStorage.key(i);
            if (itemKey.endsWith(endsWith)) {
                keysToRemove.push(itemKey);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));
    }

    private splitAliasParts(alias: string): string[] {
        if(!alias) {
            return [];
        }
        return alias
            .toLowerCase()
            .replace(/\s/gi, "_")
            .split(/:(.+)?/);
    }

    private rebuildTranslations = (translations: IMobileListItem[]) => {
        this.translations = {};
        translations.forEach(translation => {
            this.translations[translation.ListAlias.toLowerCase()] =
                this.translations[translation.ListAlias.toLowerCase()] || {};
            let t:any = { 
                Text: translation.Text
            };
            this.translations[translation.ListAlias.toLowerCase()][
                translation.Value.toLowerCase()
            ] = t;
        });
    };

    static prettify(value: string) {
        var op = "";
        if (!value){
            return "";
        }
        if (value.indexOf(":") > -1) {
            op = value.split(":")[1];
        } else {
            op = value;
        }

        return op.replace(/_/g, " ");
    }
}